<cache-date></cache-date>

<filterForm [addFilterParams]="filter.addFilterParams"></filterForm>

<br>

<h5>
	{{ 'adminstat.filterForm.isPaid' | translate }}: {{total.paidCount}}
</h5>

<h5>
	{{ 'adminstat.billing.friend.lead count' | translate }}: {{total.userCount}}
</h5>

<h5>
	{{ 'adminstat.billing.billing.usages' | translate }}: {{total.paidUserCount}}
</h5>

<table class="table table-striped">
	<thead>
		<tr>
			<th>
				{{ 'adminstat.common.Promocode' | translate }}
			</th>
			
			<th>
				{{ 'adminstat.billing.friend.lead' | translate }}</th>
			<th>
				{{ 'adminstat.filterForm.isPaid' | translate }}</th>
			<th
				(click)="getSort('leadReregCount')"
			>
				{{ 'adminstat.billing.friend.is rereg' | translate }}
				<span>{{getSortArrows('leadReregCount')}}</span>
			</th>
			
			<th
				(click)="getSort('userCount')"
			>
				{{ 'adminstat.billing.friend.lead count' | translate }}
				<span>{{getSortArrows('userCount')}}</span>
			</th>
			
			<th
				(click)="getSort('paidUserCount')"
			>
				{{ 'adminstat.billing.billing.usages' | translate }}
				<span>{{getSortArrows('paidUserCount')}}</span>
			</th>
		</tr>
	</thead>

	<tbody>
		<tr
			*ngIf="listLoader"
		>
			<td colspan="7">
				<loading [isLoad]="listLoader"></loading>
			</td>
		</tr>
		
		<tr *ngFor="let row of rows; let i = index;">
			<td>
				{{ row.promoMark }}
			</td>
			
			<td>
				<gotosupport
					[value]="row.leadUserId"
					[title]="(row.leadEmail ? row.leadEmail : row.leadUsername)"
				></gotosupport>
			</td>
			
			<td>
				{{ (row.isPaid ? 'adminstat.common.Yes' : 'adminstat.common.No') | translate }}
			</td>
			
			<td title="{{row.leadReregCount}}: {{row.leadReregId}}">
				<!--<ng-container *ngIf="row.leadReregCount > 1">
					<gotosupport [value]="row.leadReregId" [title]="translate.__A('filterForm.yes')"></gotosupport>
				</ng-container>-->
				<ng-container
					*ngIf="row.leadReregCount > 1"
				>
					{{ 'adminstat.filterForm.yes' | translate }}
				</ng-container>
				
				<ng-container
					*ngIf="row.leadReregCount <= 1"
				>
					{{ 'adminstat.filterForm.no' | translate }}
				</ng-container>
			</td>
			
			<td>
				<button-anhor (click)="showDetails(i)">
					{{row.userCount}}
				</button-anhor>
			</td>
			
			<td>
				{{ row.paidUserCount }}
			</td>
		</tr>
	</tbody>
</table>
